// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/image-carousel-item/image-carousel-item.component.scss
// module id = 369
// module chunks = 0